const riot = require('riot');
import CodeMirror from '../../../assets/codemirror/lib/codemirror.js';
import htmlmixed from '../../../assets/codemirror/mode/htmlmixed/htmlmixed.js';
import javascript from '../../../assets/codemirror/mode/javascript/javascript.js';
riot.tag2('route', '<div class="card"> <header class="card-header"> <p class="card-header-title {has-text-grey:!expanded}" onclick="{toggleExpanded}"> {route.name} ({route.widget_id})</p> <p class="card-header-icon"> <button if="{expanded && !isAutomated}" class="button is-small" onclick="{removeRoute}">Remove route</button> &nbsp;&nbsp; <span if="{widget.block_events}" onclick="{toggleExpanded}" class="tag strike">IMP</span> &nbsp;&nbsp; <span if="{widget.public}" onclick="{toggleExpanded}" class="tag is-info">PUB</span> &nbsp;&nbsp; <a href="#" onclick="{toggleExpanded}" aria-label="more options"> <span class="icon"> <i class="fas {fa-angle-down:!expanded,fa-angle-up:expanded}" aria-hidden="true"></i> </span> </a> </p> </header> <div if="{expanded}" class="card-content has-background-white-bis" style="margin-bottom:0.5rem"> <div if="{!widget.immediate_load}" class="field columns"> <div class="column"> <label for="name" class="label">Route name</label> <input class="input" name="name" ref="name" disabled="{isAutomated}" riot-value="{route.name}" onchange="{setRouteData}"> </div> <div class="column"> <label for="path" class="label">URL pattern</label> <input class="input" name="path" ref="path" riot-value="{widget.path}" onchange="{setRouteData}"> </div> <div class="column"> <label for="xpath" class="label">Insertion point</label> <input class="input" name="xpath" ref="xpath" riot-value="{widget.xpath}" onchange="{setRouteData}"> </div> <div class="column"> <label for="all_matches_{widget._id}" class="label">Render all matches</label> <input id="all_matches_{widget._id}" type="checkbox" name="all_matches_{widget._id}" ref="all_matches" onchange="{setRouteData}" class="switch is-info" checked="{widget.all_matches}"> <label for="all_matches_{widget._id}">first/all</label> </div> </div> <div class="columns"> <div class="field column"> <div class="columns"> <div class="field column"> <div class="control"> <label for="append_qry_{widget._id}" class="label">Append to URL</label> <textarea class="textarea" name="append_qry_{widget._id}" id="append_qry_{widget._id}" ref="append_qry" onchange="{setAppendQuery}" placeholder="e.g. segment=##segment_name##&route_id=##route_id##&item_id=##item_id##" rows="{(widget.append_qry || \'\').split(/&/g).length || 1}">{(widget.append_qry || \'\').replace(/&/g,\'\\n\')}</textarea> </div> </div> </div> <div class="columns"> <div class="field column"> <div class="control"> <label for="custom_data_{widget._id}" class="label">Custom data</label> <textarea class="textarea" name="custom_data_{widget._id}" id="custom_data_{widget._id}" ref="custom_data" onchange="{setCustomData}" placeholder="e.g. var_1=value_1 var_2=value_2" rows="{(widget.custom_data || []).length || 1}">{(widget.custom_data || []).join(\'\\n\')}</textarea> </div> </div> </div> <br> <div class="columns"> <div if="{!widget.immediate_load}" class="column"> <div class="field control"> <label for="retarget_enable_{widget._id}" class="label">Retargeting</label> <input type="checkbox" name="retarget_enable_{widget._id}" onchange="{toggleRetarget}" id="retarget_enable_{widget._id}" ref="retarget_enable" class="switch is-info" checked="{widget.retarget_enable}"><label for="retarget_enable_{widget._id}">Enable / disable</label> </div> </div> <div class="column"> <div class="field control"> <label for="immediate_load_{widget._id}" class="label">Keywords only</label> <input type="checkbox" name="immediate_load_{widget._id}" onchange="{setLoadMethod}" id="immediate_load_{widget._id}" ref="immediate_load" class="switch is-info" checked="{widget.immediate_load}"><label for="immediate_load_{widget._id}">Keywords / Widget.</label> </div> </div> <div if="{!widget.immediate_load}" class="column"> <div class="field control"> <label for="exclude_current_{widget._id}" class="label">Exclude current item</label> <input type="checkbox" name="exclude_current_{widget._id}" onchange="{setExcludeCurrent}" id="exclude_current_{widget._id}" ref="exclude_current" class="switch is-info" checked="{widget.exclude_current}"><label for="exclude_current_{widget._id}">Enable / disable</label> </div> </div> <div if="{!widget.immediate_load}" class="column"> <div class="field control"> <label for="block_events_{widget._id}" class="label">Block Events</label> <div class="select is-small" onchange="{setBlockEvents}"> <select name="block_events_{widget._id}" ref="block_events"> <option selected="{widget.block_events == \'\'}" value="">Disable</option> <option selected="{widget.block_events == \'block\'}" value="block">Enable</option> </select> </div> <label for="block_events_{widget._id}">Enable to block</label> </div> </div> <div class="column"> <div class="field control"> <label for="block_ads_{widget._id}" class="label">Block Ads</label> <input type="checkbox" name="block_ads_{widget._id}" onchange="{setBlockAds}" id="block_ads_{widget._id}" ref="block_ads" class="switch is-info" checked="{widget.block_ads}"><label for="block_ads_{widget._id}">block all ads</label> </div> </div> </div> </div> </div> <div class="field" if="{widget.retarget_enable}"> <hr> <div class="columns"> <div class="column"> <label for="retarget_domain" class="label">Domain</label> <input type="input" name="retarget_domain" onchange="{setRetarget}" id="retarget_domain" ref="retarget_domain" class="input" riot-value="{widget.retarget_domain}"> </div> <div class="column"> <label for="retarget_cat" class="label">Category</label> <input type="input" name="retarget_cat" onchange="{setRetarget}" id="retarget_cat" ref="retarget_cat" class="input" riot-value="{widget.retarget_cat}"> </div> <div class="column"> <label for="retarget_prefix" class="label">Prefix</label> <input type="input" name="retarget_prefix" onchange="{setRetarget}" id="retarget_prefix" ref="retarget_prefix" class="input" riot-value="{widget.retarget_prefix}"> </div> <div class="column"> <label for="retarget_posts" class="label">Retargeted posts</label> <input type="input" name="retarget_posts" onchange="{setRetarget}" id="retarget_posts" ref="retarget_posts" class="input" riot-value="{widget.retarget_posts}"> </div> <div class="column"> <label for="retarget_expire" class="label">Expiry (days)</label> <input type="input" name="retarget_expire" onchange="{setRetarget}" id="retarget_expire" ref="retarget_expire" class="input" riot-value="{widget.retarget_expire}"> </div> </div> </div> <hr if="{!widget.immediate_load}"> <div if="{!widget.immediate_load}" class="field columns"> <div class="column"> <label for="count" class="label">Count</label> <input class="input" name="count" ref="count" riot-value="{widget.data.count}" onchange="{setWidgetData}"> </div> <div class="column"> <label for="min_count" class="label">Minimal count</label> <input class="input" name="min_count" ref="min_count" riot-value="{widget.data.min_count}" onchange="{setWidgetData}"> </div> <div class="column"> <label for="img_width" class="label">Image width</label> <input class="input" name="img_width" ref="img_width" riot-value="{widget.data.img_width}" onchange="{setWidgetData}"> </div> <div class="column"> <label for="img_height" class="label">Image height</label> <input class="input" name="img_height" ref="img_height" riot-value="{widget.data.img_height}" onchange="{setWidgetData}"> </div> <div class="column"> <label for="img_height" class="label">Encoding</label> <input class="input" name="widget_encoding" ref="widget_encoding" riot-value="{widget.encoding}" onchange="{setRouteData}"> </div> </div> <hr if="{!widget.immediate_load}"> <div if="{!widget.immediate_load}" class="field columns"> <div class="column"> <div class="field is-grouped"> <div class="control"> <label for="widget_template" class="label">Template </label> </div> <div class="control"> <div class="select is-small"> <select name="editor_language" ref="editor_language" onchange="{setEditorLanguage}"> <option each="{editor_languages}" riot-value="{id}">{name}</option> </select> </div> </div> <div if="{!widget.public}" class="control"> <label class="label">Template alias &nbsp;&nbsp;&nbsp;</label> </div> <div if="{!widget.public}" class="control"> <div class="select is-small"> <select name="template_alias" ref="template_alias" onchange="{setWidgetTemplate}"> <option value="">--nothing selected--</option> <option each="{templates}" riot-value="{id}" selected="{widget.template_alias==id.toString()}">{name}</option> </select> </div> </div> <div if="{!widget.template_alias}" class="control"> <input type="checkbox" name="public" onchange="{togglePublic}" id="public_{widget._id}" ref="public" class="switch is-info" checked="{widget.public}"> <label for="public_{widget._id}">Private / Public</label> </div> <div if="{!widget.public && widget.template_alias}" class="control"> <button class="button is-small" onclick="{makeLocalCopy}">Make local copy</button> </div> </div> </div> </div> <div if="{!widget.immediate_load}" class="field columns"> <div class="column"> <div class="control"> <label for="header_title" class="label">Header title</label> <input name="header_title" ref="header_title" class="input" riot-value="{widget.header_title}" onchange="{setRouteData}"> </div><div class="control"> <label for="background_color" class="label">Background color</label> <input name="background_color" ref="background_color" class="input" riot-value="{widget.background_color}" onchange="{setRouteData}"> </div> </div> <div class="column"> <div class="control"> <label for="header_image" class="label">Header image</label> <input name="header_image" ref="header_image" class="input" riot-value="{widget.header_image}" onchange="{setRouteData}"> </div><div class="control"> <label for="background_image" class="label">Background image</label> <input name="background_image" ref="background_image" class="input" riot-value="{widget.background_image}" onchange="{setRouteData}"> </div> </div> </div> <div if="{!widget.immediate_load}" class="field control"> <textarea class="textarea" name="widget_template" ref="widget_template">{widget.template}</textarea> <div class="dragHandle" ref="widget_handle"></div> </div> <div if="{!isAutomated}" class="columns"> <div class="field column"> <input type="checkbox" name="tcf_friendly" onchange="{toggleTCFfriendly}" id="tcf_friendly_{widget._id}" ref="tcf_friendly" class="switch is-info" checked="{widget.tcf_friendly}"> <label for="tcf_friendly_{widget._id}">TCF Friendly </label> </div> <div class="column"> <div class="control field is-grouped"> <label class="label">Time Limits &nbsp;&nbsp;&nbsp;</label> <div class="select is-small"> <select name="time_limit_mode" ref="time_limit_mode" onchange="{setTimeLimitMode}"> <option each="{time_limit_modes}" riot-value="{id}" selected="{widget.time_limit.mode == id}">{mode}</option> </select> </div> </div> <div if="{widget.time_limit.mode != \'disable\'}" class="control time_limit" each="{day in time_limit_days}"> <div class="field is-grouped"> <label>{day.name}</label> <button class="button is-small {is-info:(time_limit_intervals[day.id] && time_limit_intervals[day.id][hour])}" onclick="{toggleTimeLimit(day.id,hour)}" each="{hour in time_limit_hours}">{hour}</button> </div> </div> </div> </div> <div if="{0 && !isAutomated}" class="columns"> <div class="column"> <label class="label">Frequency capping &nbsp;&nbsp;&nbsp;</label> <div class="field"> Total impressions: <input length="6" name="cap_total" ref="cap_total" riot-value="{widget.capping.total}" onchange="{setCapTotal}" type="{\'number\'}"> </div> <div class="field"> Pageviews between impressions: <input length="6" name="cap_wait" ref="cap_wait" riot-value="{widget.capping.wait}" onchange="{setCapWait}" type="{\'number\'}">. </div> <div class="field"> Maximum impressions <input length="6" name="cap_max" ref="cap_max" riot-value="{widget.capping.max}" onchange="{setCapMax}" type="{\'number\'}"> per <input length="6" name="cap_interval" ref="cap_interval" riot-value="{widget.capping.interval}" onchange="{setCapInterval}" type="{\'number\'}"> minutes. </div> </div> </div> <h4 class="title is-6">Segments</h4> <div if="{!isAutomated}" class=""> <div class="field columns"> <div class="field column"> <div class="select is-small"> <select name="new_segment" ref="new_segment"> <option value="">Select audience</option> <option each="{profiles_filtered}" riot-value="{_id}">{name}</option> </select> </div> <button class="button is-info is-small" onclick="{addSegment}">Add segment</button> </div> <div class="field column"> <input type="checkbox" name="merge_segments" onchange="{toggleMergeSegments}" id="merge_segments_{widget._id}" ref="merge_segments" class="switch is-info" checked="{widget.merge_segments}"> <label for="merge_segments_{widget._id}">Merge with campaign </label> </div> <div class="field column"> <div class="select is-small"> <select name="match_mode" ref="match_mode" onchange="{setMatchMode}"> <option>Select mode</option> <option each="{match_modes}" selected="{_id == widget.match_mode}" riot-value="{_id}">{label}</option> </select> </div> <label for="match_mode"> Segment matching</label> </div> </div> </div> <segment each="{segments_mapped}" route="1"></segment> </div> </div>', '', '', function(opts) {


		const self = this;

    self.match_modes = self.parent.parent.match_modes

		self.widgetEditor = null;
		self.expanded = false;
		self.isAutomated = self.parent.isAutomated
		self.templates = self.parent.templates
		self.time_limit_intervals = {};
		self.widget = {
			name: self.route.name,
			data: {
				count: 0,
				min_count: 0,
				img_width: 0,
				img_height: 0
			},
			template: '',
			encoding: '',
			path: '',
			xpath: '',
			segments: [],
			time_limit: {
				mode: 'disable',
				intervals: []
			},
			capping: {},
			immediate_load: false
		}

		self.on('mount',function() {
  		self.profiles = self.parent.parent.profiles;
  		console.log('route profiles',self.profiles)
		})

		self.profiles_filtered = [];

		self.segments_mapped = [];

		{
			self.time_limit_modes = [{
				id: 'disable',
				mode: 'Disabled'
			}, {
				id: 'include',
				mode: 'Any of'
			}, {
				id: 'exclude',
				mode: 'Not any of'
			}];
			self.time_limit_days = [{
				id: 1,
				name: 'Mon'
			}, {
				id: 2,
				name: 'Tue'
			}, {
				id: 3,
				name: 'Wed'
			}, {
				id: 4,
				name: 'Thu'
			}, {
				id: 5,
				name: 'Fri'
			}, {
				id: 6,
				name: 'Sat'
			}, {
				id: 0,
				name: 'Sun'
			}];
			self.time_limit_hours = Array.from(Array(24).keys());
		}

		self.editor_languages = [
			{
				id: 'javascript',
				name: 'JavaScript'
			},
			{
				id: 'htmlmixed',
				name: 'HTML'
			}
		]

		function loadWidget() {
			if(self.route.widget) {
				self.widget = self.route.widget;

				updateTimeLimits();

				self.update();
			} else if(self.route.widget_id) {
				api.service('widgets').get(self.route.widget_id)
					.then(data => {

						data.data = data.data || self.widget.data
						self.widget = data;
						self.route.widget = data;

						updateTimeLimits();

						self.update();
					})
					.catch(err => api.emit('toast', { type: 'danger', title: 'Error loading widget', content: err.message }));
			} else {
				return api.emit('toast', { type: 'danger', title: 'No widget ID provided!' });
			}
		}

    self.on('update',() => {
      self.profiles = self.parent.parent.profiles
      updateSegments()
    })

		function updateSegments() {

			let segments = {}, profiles = {};

			for(let profile of self.profiles)
				profiles[profile._id] = profile;

console.log('udating segments',profiles,self.widget.segments)

      self.widget.segments = self.widget.segments.filter(s => !!profiles[s.profile_id])

console.log('filtered segments',self.widget.segments)

			for(let segment of self.widget.segments)
				segments[segment.profile_id] = segment;

			self.profiles_filtered = self.profiles.filter(a => !segments[a._id]);
			self.segments_mapped = self.profiles.filter(a => segments[a._id]).map(a => ({ profile: a, segment: segments[a._id] }));
		}

		function updateTimeLimits() {
			for(let interval of self.widget.time_limit.intervals) {
				let time_limit = interval.split('-');
				let limit_day = Number(time_limit[0]);
				let limit_hour = Number(time_limit[1]);
				let target_limit = self.time_limit_intervals[limit_day];

				if(!target_limit)
					target_limit = self.time_limit_intervals[limit_day] = {};
				target_limit[limit_hour] = true;
			}
		}
		function updateEditor() {
		  if (self.widget.immediate_load) return;

			if(!self.widgetEditor && self.refs.widget_template) {
				self.widgetEditor = CodeMirror.fromTextArea(self.refs.widget_template, {
					lineNumbers: true,
					mode: 'javascript',
					lineWrapping: true,
					readOnly: !!self.widget.template_alias
				});

				self.widgetEditor.on('change', function(instance, changeObj) {
					self.widget.template = instance.getValue();
				});

				const MIN_HEIGHT = 200;
				let handle_y;
				let handle_h;
				self.refs.widget_handle.addEventListener('mousedown', function(ev) {
					handle_y = ev.y;
					handle_h = parseInt(window.getComputedStyle(self.widgetEditor.display.wrapper).height.replace(/px$/, ""));

					document.body.addEventListener("mousemove", on_drag);
  					window.addEventListener("mouseup", on_release);
				});
				function on_release() {
					document.body.removeEventListener("mousemove", on_drag);
					window.removeEventListener("mouseup", on_release);
				}
				function on_drag(ev) {
					self.widgetEditor.setSize(null, Math.max(MIN_HEIGHT, (handle_h + ev.y - handle_y)) + "px");
				}
				if (!self.widget.template) console.log('widget template is EMPTY')
  			self.widgetEditor.setValue(self.widget.template || '')
			}
		  if (self.widgetEditor) {
		    self.widgetEditor.setOption('readOnly',!!self.widget.template_alias)
        const wrap = self.widgetEditor.getWrapperElement()
		    wrap.style.background = self.widget.template_alias ? '#efefef' : '#fff'
		  }
 		}

    self.on('update',updateEditor)

		this.setEditorLanguage = function(e) {
			e.preventDefault();
			self.widgetEditor.swapDoc(CodeMirror.Doc(self.widget.template, self.refs.editor_language.value));
		}.bind(this)
		this.setWidgetTemplate = function(e) {
		  e.preventDefault()
		  self.widget.template_alias = self.refs.template_alias.value
		}.bind(this)
		this.makeLocalCopy = function(e) {
		  e.preventDefault()
		  var template = self.templates.find(t => t.id==self.widget.template_alias)
		  self.widget.template = template.template
		  self.widgetEditor.setValue(template.template)
		  self.widget.template_alias = null
		}.bind(this)
		this.removeRoute = function(e) {
			self.parent.removeRoute(e);
			e.preventUpdate = true;
		}.bind(this)
		this.toggleExpanded = function(e) {
			e.preventDefault();
			self.expanded = !self.expanded;

			if(self.expanded)
				loadWidget();
		}.bind(this)
		this.setRouteData = function(e) {
			e.preventDefault();

			let target = e.target;
			let ref = target.getAttribute('ref');
			let type = target.getAttribute('type');

console.log('routeData',ref,target.value,target.checked)

			if(ref === 'name') {
				self.route[ref] = target.value;
				self.widget[ref] = target.value;
			} else if (type=='checkbox') {
			  self.widget[ref.replace('widget_', '')] = target.checked
			} else {
				self.widget[ref.replace('widget_', '')] = target.value;
			}
		}.bind(this)

		this.togglePublic = function(e) {
		  self.widget.public = !self.widget.public
		}.bind(this)

		this.setWidgetData = function(e) {
			e.preventDefault();

			let target = e.target;
			let ref = target.getAttribute('ref');

			self.widget.data[ref.replace('widget_', '')] = target.value;
		}.bind(this)
		this.setExcludeCurrent = function(e) {
			e.preventDefault();
			self.widget.exclude_current = self.refs.exclude_current.checked;
		}.bind(this)
		this.setAppendQuery = function(e) {
			e.preventDefault();
			self.widget.append_qry = self.refs.append_qry.value.replace(/\n/g,'&');
		}.bind(this)
    this.setCustomData = function(e) {
     e.preventDefault();
     self.widget.custom_data = self.refs.custom_data.value.split(/\s+/g);
    }.bind(this)
		this.setBlockEvents = function(e) {
			e.preventDefault();
			self.widget.block_events = self.refs.block_events.value;
		}.bind(this)
		this.toggleRetarget = function(e) {
			e.preventDefault();
			self.widget.retarget_enable = self.refs.retarget_enable.checked;
    }.bind(this)
		this.setRetarget = function(e) {
			e.preventDefault();
		  self.widget.retarget_domain = self.refs.retarget_domain.value;
		  self.widget.retarget_cat = self.refs.retarget_cat.value;
		  self.widget.retarget_prefix = self.refs.retarget_prefix.value;
		  self.widget.retarget_posts = self.refs.retarget_posts.value;
		  self.widget.retarget_expire = self.refs.retarget_expire.value;
		}.bind(this)
		this.toggleMergeSegments = function(e) {
			e.preventDefault();
			self.widget.merge_segments = self.refs.merge_segments.checked;
	  }.bind(this)
		this.toggleTCFfriendly = function(e) {
			e.preventDefault();
			self.widget.tcf_friendly = self.refs.tcf_friendly.checked;
	  }.bind(this)
	  this.setLoadMethod = function(e) {
			e.preventDefault();
			self.widget.immediate_load = self.refs.immediate_load.checked;
		}.bind(this)
	  this.setBlockAds = function(e) {
			e.preventDefault();
			self.widget.block_ads = self.refs.block_ads.checked;
		}.bind(this)
		this.setMatchMode = function(e) {
			e.preventDefault();
			self.widget.match_mode = self.refs.match_mode.value;
		}.bind(this)
		this.toggleTimeLimit = function(day, hour) {
			return function(e) {
				e.preventDefault();
				let target_limit = self.time_limit_intervals[day];

				if(!target_limit)
					target_limit = self.time_limit_intervals[day] = {};
				if(!target_limit[hour]) {
					target_limit[hour] = true;
					self.widget.time_limit.intervals.push(String(day) + '-' + String(hour));
				} else {
					delete target_limit[hour];
					self.widget.time_limit.intervals.splice(self.widget.time_limit.intervals.indexOf(String(day) + '-' + String(hour)), 1);
				}
			}
		}.bind(this)
		this.setTimeLimitMode = function(e) {
			e.preventDefault();
			self.widget.time_limit.mode = self.refs.time_limit_mode.value;
		}.bind(this)
		this.setCapTotal = function() {
			e.preventDefault();
			self.widget.capping.total = self.refs.cap_total.value;
		}.bind(this)
		this.setCapWait = function() {
			e.preventDefault();
			self.widget.capping.wait = self.refs.cap_wait.value;
		}.bind(this)
		this.setCapMax = function() {
			e.preventDefault();
			self.widget.capping.max = self.refs.cap_max.value;
		}.bind(this)
		this.setCapInterval = function() {
			e.preventDefault();
			self.widget.capping.interval = self.refs.cap_interval.value;
		}.bind(this)
		this.addSegment = function(e) {
			e.preventDefault();

			let id = self.refs.new_segment.value;
			if(!id) return api.emit('toast', { type: 'danger', title: 'Select segment first' });

			let profile = self.profiles.find(a => a._id == id);
			if(!profile) return api.emit('toast', { type: 'danger', title: 'Invalid segment ID' });

			let segment = {
				fixed_mode: 'disable',
				time_limit: {
					mode: 'disable',
					intervals: []
				},
				goal_limit: {
					mode: 'disable'
				},
				profile_id: id,
				name: profile.name,
				selected: []
			};

			self.widget.segments.push(segment);
			self.segments_mapped.push({ profile, segment });
			self.profiles_filtered = self.profiles_filtered.filter(a => a._id !== id);

			self.update();
		}.bind(this)
		this.removeSegment = function(e) {
			e.preventDefault();

			self.profiles_filtered.push(e.item.profile);
			self.segments_mapped = self.segments_mapped.filter(a => a.segment.profile_id !== e.item.segment.profile_id);
			self.widget.segments = self.widget.segments.filter(a => a.profile_id !== e.item.segment.profile_id);

			self.update();
		}.bind(this)
		this.setDefaultSegment = function(e) {
			e.preventDefault();

			for(let segment of self.widget.segments) {
				if(segment.isDefault)
					delete segment['isDefault'];
				else if(segment.profile_id === e.item.segment.profile_id) {
					segment['isDefault'] = true;
					segment['pinned'] = false
			  }
			}

			self.update();
		}.bind(this)
		this.setPinnedSegment = function(e) {
			e.preventDefault();

			for(let segment of self.widget.segments) {
				if(segment.pinned)
					delete segment['pinned']
				else if(segment.profile_id === e.item.segment.profile_id) {
					segment['pinned'] = true;
					segment.pinned_posts = segment.pinned_posts || 1
				}
			}

			self.update();
		}.bind(this)
});
